// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VideoCard_video-card__3Yxv1 {
  width: 100%;
  border-radius: 5px;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  overflow-y: hidden;
}
.VideoCard_video-card__3Yxv1 .VideoCard_video-loader__jCORB {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.VideoCard_video-card__3Yxv1 .VideoCard_video-loader__jCORB .ant-skeleton {
  width: 100%;
  height: 100%;
}
.VideoCard_video-card__3Yxv1 .VideoCard_video-loader__jCORB .ant-skeleton .ant-skeleton-input {
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/Admin/Components/VideoCard/VideoCard.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AACF;AAAE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAEJ;AADI;EACE,WAAA;EACA,YAAA;AAGN;AAFM;EACE,WAAA;EACA,YAAA;AAIR","sourcesContent":[".video-card {\n  width: 100%;\n  border-radius: 5px;\n  height: fit-content;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  position: relative;\n  overflow-y: hidden;\n  .video-loader {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    :global(.ant-skeleton) {\n      width: 100%;\n      height: 100%;\n      :global(.ant-skeleton-input) {\n        width: 100%;\n        height: 100%;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"video-card": `VideoCard_video-card__3Yxv1`,
	"video-loader": `VideoCard_video-loader__jCORB`
};
export default ___CSS_LOADER_EXPORT___;
